module.exports = __webpack_public_path__ + "img/icon-preview.6698eb84.svg";